import React from 'react';
import { withRouter } from 'react-router-dom';
import { translate } from 'react-i18next';

import CollapsableMenuItem from 'secured/components/layout/menu/CollapsableMenuItem';
import ActiveLink from 'secured/components/layout/menu/ActiveLink';

const Configuration = ({
  company,
  subcompany,
  isCollapsed,
  location,
  permissions,
  t,
  toggleMenu,
}) =>
  permissions['acl.employees.get'] ||
  permissions['acl.exchanges.get'] ||
  permissions['acl.projects.get'] ||
  permissions['acl.cost_centers.get'] ||
  permissions['acl.catalogs.get'] ||
  permissions['acl.accounts.get'] ||
  permissions['acl.depreciations.get'] ||
  permissions['acl.providers_clients.get'] ||
  permissions['acl.locations.get'] ||
  permissions['acl.custom_group.get'] ||
  permissions['acl.custom_employee.get'] ? (
    <CollapsableMenuItem
      label={t('menu.configuration')}
      opened={!isCollapsed}
      icon="sliders"
      handleToggle={(collapsed) => toggleMenu('configuration', collapsed)}
    >
      <ul className="submenu-list">
        {permissions['acl.depreciations.get'] && (
          <li>
            <ActiveLink
              pathname={location.pathname}
              to={`/companies/${company.id}/subcompanies/${subcompany.id}/depreciations`}
            >
              <i className="fa fa-calculator fa-lg" />
              {t('menu.depreciations')}
            </ActiveLink>
          </li>
        )}
        {permissions['acl.cost_centers.get'] && (
          <li>
            <ActiveLink
              pathname={location.pathname}
              to={`/companies/${company.id}/subcompanies/${subcompany.id}/cost_centers`}
            >
              <i className="fa fa-book fa-lg" />
              {t('menu.costCenters')}
            </ActiveLink>
          </li>
        )}
        {permissions['acl.accounts.get'] && (
          <li>
            <ActiveLink
              pathname={location.pathname}
              to={`/companies/${company.id}/subcompanies/${subcompany.id}/accounts`}
            >
              <i className="fa fa-archive fa-lg" />
              {t('menu.accounts')}
            </ActiveLink>
          </li>
        )}
        {permissions['acl.accounts.get'] && (
          <li>
            <ActiveLink
              pathname={location.pathname}
              to={`/companies/${company.id}/subcompanies/${subcompany.id}/subaccounts`}
            >
              <i className="fa fa-archive fa-lg" />
              {t('menu.subaccounts')}
            </ActiveLink>
          </li>
        )}
        {permissions['acl.asset_level.get'] && (
          <li>
            <ActiveLink
              pathname={location.pathname}
              to={`/companies/${company.id}/subcompanies/${subcompany.id}/asset_level`}
            >
              <i className="fa fa-list-ol fa-lg" />
              {t('menu.asset_level')}
            </ActiveLink>
          </li>
        )}

        {/* Groups */}
        {permissions['acl.custom_group.get'] && (
          <li>
            <ActiveLink
              pathname={location.pathname}
              to={`/companies/${company.id}/subcompanies/${subcompany.id}/groups`}
            >
              <i className="fa fa-users fa-lg" />
              {t('menu.groups')}
            </ActiveLink>
          </li>
        )}

        {/* ConfigEmpleados
        {permissions["acl.employees.get"] && (
          <li>
            <ActiveLink
              pathname={location.pathname}
              to={`/companies/${company.id}/subcompanies/${subcompany.id}/custom_fields_employees`}
            >
              <i className="fa fa-users fa-lg" />
              {t("menu.custom_fields_employees")}
            </ActiveLink>
          </li>
        )} */}

        {permissions['acl.employees.get'] && (
          <li>
            <ActiveLink
              pathname={location.pathname}
              to={`/companies/${company.id}/subcompanies/${subcompany.id}/employees`}
            >
              <i className="fa fa-users fa-lg" />
              {t('menu.employees')}
            </ActiveLink>
          </li>
        )}
        {permissions['acl.catalogs.get'] && (
          <li>
            <ActiveLink
              pathname={location.pathname}
              to={`/companies/${company.id}/subcompanies/${subcompany.id}/catalogs`}
            >
              <i className="fa fa-list-ul fa-lg" />
              {t('menu.catalogs')}
            </ActiveLink>
          </li>
        )}
        {permissions['acl.locations.get'] && (
          <li>
            <ActiveLink
              pathname={location.pathname}
              to={`/companies/${company.id}/subcompanies/${subcompany.id}/locations`}
            >
              <i className="fa fa-map-marker fa-lg" />
              {t('menu.locations')}
            </ActiveLink>
          </li>
        )}
        {permissions['acl.projects.get'] && (
          <li>
            <ActiveLink
              pathname={location.pathname}
              to={`/companies/${company.id}/subcompanies/${subcompany.id}/projects`}
            >
              <i className="fa fa-university fa-lg" />
              {t('menu.projects')}
            </ActiveLink>
          </li>
        )}
        {permissions['acl.providers_clients.get'] && (
          <li>
            <ActiveLink
              pathname={location.pathname}
              to={`/companies/${company.id}/subcompanies/${subcompany.id}/providers`}
            >
              <i className="fa fa-shopping-cart fa-lg" />
              {t('menu.providers')}
            </ActiveLink>
          </li>
        )}
        {permissions['acl.notifications_config.get'] && (
          <li>
            <ActiveLink
              pathname={location.pathname}
              to={`/companies/${company.id}/subcompanies/${subcompany.id}/notifications_config`}
            >
              <i className="fa fa-bell fa-lg" />
              {t('menu.notifications_config')}
            </ActiveLink>
          </li>
        )}
      </ul>
    </CollapsableMenuItem>
  ) : null;

export default withRouter(translate()(Configuration));



// WEBPACK FOOTER //
// src/modules/secured/components/layout/menu/Configuration.js